import React from "react";
import { Layout, Typography, Flex } from "antd";
import { SettingOutlined, PhoneOutlined } from "@ant-design/icons";
import { BsChatLeftText } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import { useChatSidebarContext } from "../../../context/ChatSidebarScreenContext";
import { useSettingSidebarContext } from "../../../context/SettingSidebarScreenContext";
import "./index.scss";

const { Sider } = Layout;
const { Text } = Typography;

const ChatIcon = BsChatLeftText as unknown as React.FC;

const Sidebar = () => {
  const { setCurrentScreen } = useChatSidebarContext();
  const { setSettingsCurrentScreen } = useSettingSidebarContext();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <Sider className="navigation-sider" width="80px">
      {/* Calls */}
      <Flex
        gap={4}
        vertical
        align="center"
        justify="center"
        className={`cursor-pointer sidebar-item ${isActive("/calls") ? "active" : ""}`}
        onClick={() => navigate("/calls")}
      >
        <PhoneOutlined style={{ fontSize: "26px", color: "#fff" }} />
        <Text className="module-title">Calls</Text>
      </Flex>

      {/* Chat */}
      <Flex
        vertical
        gap={4}
        align="center"
        justify="center"
        className={`cursor-pointer sidebar-item ${isActive("/chat") ? "active" : ""}`}
        onClick={() => {
          navigate("/chat");
          setCurrentScreen("chats");
        }}
      >
        <Flex style={{ fontSize: "26px", color: "#fff" }}>
          <ChatIcon />
        </Flex>
        <Text className="module-title">Chat</Text>
      </Flex>

      {/* Settings */}
      <Flex
        vertical
        gap={4}
        align="center"
        justify="center"
        className={`cursor-pointer sidebar-item ${isActive("/settings") ? "active" : ""}`}
        onClick={() => {
          navigate("/settings");
          setSettingsCurrentScreen("main");
        }}
      >
        <SettingOutlined style={{ fontSize: "26px", color: "#fff" }} />
        <Text className="module-title">Settings</Text>
      </Flex>
    </Sider>
  );
};

export default Sidebar;
